import { getMenuPermission } from '@/services/user';
import { getUuid } from '@/utils';
import { setLocalStorage } from '@/utils/cookies';
import { MenuItemProps as AntdMenuItemProps } from '@sinohealth/butterfly-ui-components/lib';
import routerConfig from './router';
const { NODE_ENV } = process.env;
export const isDev = NODE_ENV === 'development';

let menuConfig: MenuItemProps[] = [
  {
    label: '权限管理',
    key: 'rootAdmin',
    children: [
      {
        label: '资源管理',
        path: '/rootAdmin/resourceAdmin',
      },
      {
        label: '业务管理',
        path: '/rootAdmin/businessAdmin',
      },
      {
        label: '应用管理',
        path: '/rootAdmin/applicationAdmin',
      },
      {
        label: '小程序管理',
        path: '/rootAdmin/miniAppAdmin',
      },
      {
        label: '企业微信管理',
        key: 'wordWx',
        children: [
          {
            label: '企微应用管理',
            path: '/rootAdmin/wordWechar/app',
          },
          {
            label: '企微授权登录管理',
            path: '/rootAdmin/wordWechar/auth',
          },
          {
            label: '代开发应用模板管理',
            path: '/rootAdmin/wordWechar/template',
          },
          {
            label: '授权服务商企业信息',
            path: '/rootAdmin/wordWechar/firm',
          }
        ]
      },
      {
        label: '菜单管理',
        path: '/rootAdmin/menuAdmin',
      },
      {
        label: '模块管理',
        path: '/rootAdmin/moduleAdmin',
      },
      {
        label: '用户管理',
        path: '/rootAdmin/userAdmin',
      },
      {
        label: '日志管理',
        path: '/rootAdmin/logAdmin',
      },
    ],
  },
  {
    label: '客户管理',
    key: 'customer',
    children: [
      {
        label: '租户管理',
        path: '/customer/tenant',
      },
      {
        label: '组织管理',
        path: '/customer/organ',
        // children: [
        //   {
        //     label: '组织详情',
        //     path: '/customer/organ/detail',
        //   },
        // ],
      },
      {
        label: '部门管理',
        path: '/customer/department',
      },
      {
        label: '角色管理',
        path: '/customer/role',
      },
      {
        label: '员工管理',
        path: '/customer/employees',
      },
    ],
  },
  {
    label: '标签管理',
    key: 'labelsAdmin',
    children: [
      {
        label: '标签管理',
        path: '/labelsAdmin/labelTypeAdmin',
      },
      // {
      //   label: '标签库管理',
      //   path: '/labelsAdmin/labelLibrary',
      // },
    ],
  },
  {
    label: '支付管理',
    key: 'payManage',
    children: [
      {
        label: '支付业务管理',
        path: '/payManage/business',
      },
      {
        label: '支付渠道管理',
        path: '/payManage/channel',
      },
    ],
  },
  {
    label: '通知管理',
    key: 'noticeAdmin',
    children: [
      {
        label: '通知渠道管理',
        path: '/noticeAdmin/channel',
      },
      {
        label: '通知类型管理',
        path: '/noticeAdmin/classPages',
      },
      {
        label: '通知模板管理',
        path: '/noticeAdmin/templatePages',
      },
      {
        label: '业务通知管理',
        path: '/noticeAdmin/businessNotice',
      },
      {
        label: '通知停用管理',
        path: '/noticeAdmin/deactivate',
      },
      {
        label: '应用消息管理',
        path: '/noticeAdmin/appMessage',
      },
      {
        label: '系统黑白名单',
        path: '/noticeAdmin/systemList',
      },
    ],
  },
  {
    label: '数据管理',
    key: 'datamanagement',
    children: [
      {
        label: '数据湖',
        children: [
          {
            label: '国家医保局',
            path: '/datamanagement/datalake/medicalInsurance',
          },
          {
            label: '互联网医院监管平台',
            path: '/datamanagement/datalake/platform',
          },
          {
            label: '国家医政医管局',
            path: '/datamanagement/datalake/nationalMedicalBureau',
          },
          {
            label: '中康数据中台',
            path: '/datamanagement/datalake/dataCenter',
          },
        ],
      },
    ],
  },
];

export class MenuItem {
  parent: MenuItem | null;

  key: string = '';

  children: MenuItem[];

  path: string = '';

  constructor(props: MenuItemProps) {
    Object.assign(this, props);
    this.parent = props.parent || null;
    this.key = props.key || props.path || getUuid();
    this.children = props.children
      ? props.children.map((config) => new MenuItem({ ...config, parent: this }))
      : [];
  }
}

export interface MenuItemProps extends AntdMenuItemProps {
  label: string;
  key?: string;
  path?: string;
  parent?: MenuItem;
  children?: MenuItemProps[];
}

export function mapMenuConfig(menu: MenuItem[], fn: any) {
  menu.forEach((item) => {
    fn(item);
    if (item.children) {
      mapMenuConfig(item.children, fn);
    }
  });
}

export function mapMenuParent(menuItem: MenuItem, fn: any) {
  if (menuItem.parent) {
    fn(menuItem.parent);
    mapMenuParent(menuItem.parent, fn);
  }
}

// 根据页面资源code从路由表配置提取页面菜单路径
const getPathFormRouterConfig = (code: string) => {
  const allRoute = routerConfig[0].children || [];
  const pagePath = allRoute.filter((item: any) => item.code === code)[0];
  return pagePath?.path;
};
// 转换后台配置的菜单数据为本地要求的菜单数据格式
const transformAsyncMenuConfig = (menus: any) => {
  return menus.map((item: any) => {
    const code = item.data?.resourceCode;
    const visible = item.data?.visible;
    return {
      label: item.name,
      path: code && getPathFormRouterConfig(code),
      visible: visible,
      children: item.children ? transformAsyncMenuConfig(item.children) : [],
    };
  });
};
// 获取菜单配置数据
export function getMenuConfig() {
  if (isDev && false) return Promise.resolve(menuConfig.map((config) => new MenuItem(config)));
  return getMenuPermission().then((data: any) => {
    // 缓存
    setLocalStorage('permission', data.permission);
    const newMenuConfig = transformAsyncMenuConfig(data.menu);
    console.log(newMenuConfig);
    // 加一个判断，如果是开发环境用上面那一份，如果是生产环境，取接口返回的
    return newMenuConfig.map((config: any) => new MenuItem(config));
  });
}

export default menuConfig;
